/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 17:09:43
 */

import * as request from '@/utils/request'

export default {
  // 获取短信链接
  getSMSLinkList(data){
    return request.post('/customer/getUrlLinkList', data)
  },
  // 获取签约链接
  getQyLink(data) {
    return request.post('/customer/esign_file_list', data)
  },	
  /**
   * getCustomerList
   * @description 人才签约列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCustomerList(data) {
    return request.post('/customer/list', data)
  },
  /**
   * 保存人才签约
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveCustomer(data) {
    return request.post('/customer/store', data)
  },
  /**
   * 保存人才签约
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  batchSaveCustomer(data) {
    return request.post('/customer/batchStore', data)
  },
  /**
   * getCategoryInfo
   * @description 获取人才签约详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCustomerInfo(id) {
    let data = {id:id}
    return request.post('/customer/get_info', data)
  },
  /**
   * deleteCustomer
   * @description 删除人才签约
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteCustomer(id) {
    let data = {id:id}
    return request.post('/customer/delete', data)
  },
   /**
   * @description 获取分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getCustomerCategoryList() {
    return request.get('/customer/category_list')
  },
  /**
   * @description 获取二维码
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  // getQRCode(data) {
  //   return request.post('/mission/store', data)
  // },

  /**
   * @description 当前公司是否支持批量人才导入
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  isImport(data) {
    return request.post('/customer/is_import', data)
  },
  // 根据签约记录ID查询印章信息
  getsignInfoById(data) {
    return request.get('/customer/sign/info', data)
  },
  // 批量导出签约文件
  postExportSignPdf(data) {
    return request.post('/customer/exportSignPdf', data)
  }
}